import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box, Button, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { MeetingsContainer } from '../meetings/meetings-container';
import { MemoriesContainer } from '../memories/memories-container';
import { useHistory } from 'react-router-dom';
import { InProgressContainer } from '../in-progress/in-progress-meetings';

const AntTabs = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: theme.ui.primary,
  },
}))(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: theme.ui.primary,
      opacity: 1,
    },
    '&$selected': {
      color: theme.ui.primary,
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: theme.ui.primary,
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 24,
  },

  createMeeting: {
    marginRight: 16,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '30px 0',
  },
  tab: {
    marginBottom: 16,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export const HomeTab = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Box className={classes.header} flexWrap='wrap'>
        <Box flexGrow={1}>
          <Typography variant='h5'>Meetings</Typography>
        </Box>
        <Box className={classes.createMeeting}>
          <Button
            color='primary'
            variant='outlined'
            onClick={() => history.push('/createmeeting')}
          >
            Create New Meeting
          </Button>
        </Box>
      </Box>

      <AntTabs value={value} onChange={handleChange} className={classes.tab}>
        <AntTab label='In Coming' />
        <AntTab label='In Progress' />
        <AntTab label='Memories' />
      </AntTabs>

      <TabPanel value={value} index={0} dir={theme.direction}>
        <MeetingsContainer />
      </TabPanel>

      <TabPanel value={value} index={1} dir={theme.direction}>
        <InProgressContainer />
      </TabPanel>

      <TabPanel value={value} index={2} dir={theme.direction}>
        <MemoriesContainer />
      </TabPanel>
    </div>
  );
};
